import React from "react";
import { createRoot, hydrateRoot } from "react-dom/client";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import "@/index.css";
import App from "@/App";

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 60_000,
      refetchOnWindowFocus: false,
    },
  },
});

const rootElement = document.getElementById("root");
if (window.location.pathname !== "/" && window.location.pathname.endsWith("/")) {
  window.history.replaceState(
    window.history.state,
    "",
    `${window.location.pathname.slice(0, -1)}${window.location.search}${window.location.hash}`,
  );
}
const app = (
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <App />
    </QueryClientProvider>
  </React.StrictMode>
);

if (rootElement.hasChildNodes()) {
  hydrateRoot(rootElement, app, {
    onRecoverableError: (error, errorInfo) => console.error(error, errorInfo.componentStack),
  });
} else {
  createRoot(rootElement).render(app);
}

if (typeof window !== "undefined" && window.__SDRC_PRERENDER__) {
  window.setTimeout(() => delete window.__SDRC_PRERENDER__, 0);
}
